import { sanitizeUrl } from '@braintree/sanitize-url'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      methods: {
        $sanitizeUrl (url) {
          return sanitizeUrl(url)
        },
      },
    })
  },
}
